import React from "react";
import { Popover, Space, Tag, Typography, Avatar, Button } from "antd";
import { IBettingWebsiteLanguage } from "../../../../types/BettingWebsite.Language";
import { Link } from "react-router-dom";
import { EditOutlined } from "@ant-design/icons";

const { Text } = Typography;

type Props = {
  languages: IBettingWebsiteLanguage[];
  currentLang?: "En" | "Ar" | "Fr"; // to choose display language
  id: string;
  page: number;
  pageSize: number;
};

export const LanguagesPopover: React.FC<Props> = ({
  languages,
  currentLang = "En",
  id,
  page,
  pageSize,
}) => {
  const content = (
    <div className="space-y-2 max-w-xs">
      {languages.map((lang) => (
        <div key={lang.id} className="flex items-center justify-start gap-3">
          <Avatar
            src={`https://flagcdn.com/${lang.Flag.toLowerCase()}.svg`}
            size="small"
            alt={lang.Country[currentLang]}
          />
          <Text>{lang.Country[currentLang]}</Text>
        </div>
      ))}
    </div>
  );

  return (
    <Popover
      title={
        <div className="flex flex-row w-full justify-between border-b pb-0.5">
          <span>Supported Languages</span>
          <Link
            to={`/betting-websites/edit-languages/${id}?page=${
              page + 1
            }&pageSize=${pageSize}`}
          >
            <Button size="small" type="link" icon={<EditOutlined />} />
          </Link>
        </div>
      }
      content={content}
      trigger="hover"
      placement="right"
    >
      <Tag color="purple" className="cursor-pointer">
        Show Languages
      </Tag>
    </Popover>
  );
};
